import { tns } from 'tiny-slider/src/tiny-slider'

const Slider = () => {
  const elements = [ ...document.querySelectorAll('.js-slider') ]
  const sliders = {}
  if (!elements.length) return

  let windowWidth = window.innerWidth
  window.addEventListener('resize', () => {
    windowWidth = window.innerWidth
  })

  const getGutterWidth = windowWidth => {
    if (windowWidth < 1000) {
      return 40
    } else if (windowWidth < 1440) {
      return 50
    } else {
      return 60
    }
  }

  const getEdgePadding = windowWidth => {
    if (windowWidth < 1000) {
      return 80
    } else if (windowWidth < 1440) {
      return 100
    } else {
      return 120
    }
  }

  elements.forEach(slider => {
    const { id } = slider
    const singleView = slider.dataset.single === 'true'
    sliders[id] = {
      slider: tns({
        container: slider,
        items: 1,
        slideBy: 'page',
        mouseDrag: true,
        speed: 600,
        nav: true,
        controls: false,
        edgePadding: singleView || windowWidth < 640
          ? 0
          : getEdgePadding(windowWidth),
        gutter: singleView || windowWidth < 640
          ? 0
          : getGutterWidth(windowWidth)
      }),
      singleView
    }
  })

  Object.keys(sliders).forEach(id => {
    const slider = sliders[id].slider
    slider.events.on('indexChanged', () => {
      const { slideItems, indexCached, index } = slider.getInfo()
      slideItems[indexCached].classList.remove('c-slider-item--active')
      slideItems[index].classList.add('c-slider-item--active')
    })
  });
  [ ...document.querySelectorAll('.js-slider-nav') ].forEach(button => {
    button.style.opacity = 1
    button.addEventListener('click', function (e) {
      e.preventDefault()
      const { target, direction } = this.dataset
      const slider = sliders[target].slider
      if (direction === 'prev') slider.goTo('prev')
      if (direction === 'next') slider.goTo('next')
    })
  })
}

export default Slider



// WEBPACK FOOTER //
// ./src/js/modules/Slider.js